import React from "react"
import AltGrid from "../../components/alternate-grid/alternate-grid"

export default ({ slice }) => {
  return <AltGrid items={slice.fields} />
}
